import endpoints from '@/constants/endpoints';
import axiosV2 from '@/data/api/axiosv2';
import { ITEMS_TABLE_PAGE_LIMIT } from '@/utils/constants';
import {
  DetailOrdersFiltersResponse,
  DetailOrdersResponse,
} from '../model/orders/detailOrdersDto';

export const getDetailOrders = async (args: {
  pageNumber?: number;
  orderNumber?: string;
  deliveryDateRange?: [string, string];
  sellerIds?: string[];
  statusId?: string;
  remissionStatusId?: string;
  kamIds?: string[];
}): Promise<DetailOrdersResponse> => {
  const endpoint = endpoints.orders.getOrdersDetail;

  const sellerIdsFilter =
    args.sellerIds && args.sellerIds.length
      ? args.sellerIds.join(',')
      : undefined;

  const kamsFilter =
    args.kamIds && args.kamIds.length ? args.kamIds.join(',') : undefined;

  const response = await axiosV2.get<DetailOrdersResponse>(endpoint, {
    params: {
      limit: ITEMS_TABLE_PAGE_LIMIT,
      ...(args.pageNumber && { page: `${args.pageNumber}` }),
      ...(args.orderNumber && { query: `${args.orderNumber}` }),
      ...(args.deliveryDateRange && {
        start_delivery_date: args.deliveryDateRange[0],
        end_delivery_date: args.deliveryDateRange[1],
      }),
      ...(sellerIdsFilter && { seller_business_id: sellerIdsFilter }),
      ...(args.statusId && { status: args.statusId }),
      ...(args.remissionStatusId && { evidences: args.remissionStatusId }),
      ...(kamsFilter && { kam_id: kamsFilter }),
    },
  });

  return response;
};

export const getDetailOrderFilters =
  async (): Promise<DetailOrdersFiltersResponse> => {
    const endpoint = endpoints.orders.filters;
    return await axiosV2.get<DetailOrdersFiltersResponse>(endpoint);
  };
